import React from 'react';
import Configuracion from "./Configuracion";


export const ConfiguracionContext = React.createContext("");